export const getSafeHtml = (content) => {
  if (content) {
    return content.replace(
      /[<>'"]/g,
      (txt) =>
        `&${
          {
            "'": 'apos',
            '"': 'quot',
            '&': 'amp',
            '<': 'lt',
            '>': 'gt',
          }[txt]
        };`,
    );
  }
  return '';
};
